import Cookie from 'js-cookie'
import { api } from '@/config'
import * as response from '@/util/response'
/* 检查用户登录状态*/
/* 检查用户登录状态*/
export function checkLogin(callback, success) {
  syncHttpRequest(api.mall.checkCode, 'GET', null, function (res) {
    // res.status.code = 403;
    if (res.status.code == response.Success) {
      localStorage.setItem('areaId1', res.data.muser.cityId)
      Cookie.set('mall_token', res.data.mtoken, 100 * 365 * 24 * 60 * 60 * 1000);
      Cookie.set('mall_user', res.data.muser, 100 * 365 * 24 * 60 * 60 * 1000);
      success();
    } else if (res.status.code == response.Forbidden) {
      console.log('Forbidden， 可能原因是SSO登录成功的用户本地不存在');
      callback();
    } else {
      redirectToLogin();
    }
  });
}

/* 跳转到登录页面 */
export function redirectToLogin() {
  if (api.mall.on) {
    location.href = api.mall.login + "?jumpto=" + location.href;
  } else {
    console.log('--- to login is off ---')
  }
}

function syncHttpRequest(url, method, params, callback) {
  var request = new XMLHttpRequest()
  request.open(method, url, false)
  request.onload = function () {
    var json = {}
    try {
      json = JSON.parse(request.response)
    } catch (err) {
      //console.error(err)
    }
    callback(json)
  }
  var token = Cookie.get('mall_token');
  if (token) {
    request.setRequestHeader('token', token);
  }
  if (method === 'POST') {
    request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
  }
  request.send(params)
}



// WEBPACK FOOTER //
// ./src/util/login.js